module.exports = __webpack_public_path__ + "img/android.b1dbfb1a.svg";